import styled from 'styled-components'

export const Wrapper = styled.div`
  padding-bottom: 24px;
`

export const FiltersWrapper = styled.form`
  margin-top: 32px;
  margin-bottom: 48px;
`

export const ModalInfo = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
`

export const Title = styled.h3`
  font-size: ${({ theme }) => theme.font.sizes.medium};
  font-weight: ${({ theme }) => theme.font.semiBold};
  color: ${({ theme }) => theme.colors.neutralBlack};
`

export const HeaderModal = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
  /* margin-bottom: 20px; */
`

export const ObservationWrapper = styled.div`
  display: flex;
  gap: 10px;
  /* margin-bottom: 20px; */
`

export const Subtitle = styled.h3`
  color: ${({ theme }) => theme.ds.colors.neutral500};
  font-size: ${({ theme }) => theme.ds.typography.size.small};
  font-weight: ${({ theme }) => theme.font.normal};
  text-align: justify;
  margin: 25px 0;
`

export const TriangleAlertIconWrapper = styled.span`
  svg {
    width: 24px;
    height: 24px;
    path {
      fill: ${({ theme }) => theme.ds.colors.terciary300};
    }
  }
`
export const CancelledContainer = styled.div`
  display: block;
  padding: 16px;
  text-align: left;
  background: ${({ theme }) => theme.ds.colors.danger25};
  margin-bottom: 20px;
`

export const CancelledTitle = styled.strong`
  color: ${({ theme }) => theme.ds.colors.danger700};
  font-size: ${({ theme }) => theme.font.sizes.xsmall};
`

export const CancelledText = styled.p`
  color: ${({ theme }) => theme.ds.colors.neutral900};
  font-size: ${({ theme }) => theme.font.sizes.xsmall};

  &:first-of-type {
    margin-bottom: 15px;
  }
`

export const ContainerInfo = styled.div`
  display: block;
  text-align: left;
  font-size: ${({ theme }) => theme.font.sizes.xsmall};

  .schedule-name {
    margin-bottom: 12px;
  }

  .black {
    color: ${({ theme }) => theme.ds.colors.black};
  }

  .orange {
    color: ${({ theme }) => theme.ds.colors.terciary700};
    font-size: ${({ theme }) => theme.ds.typography.size.small};
  }

  h1 {
    font-weight: ${({ theme }) => theme.font.bold};
    color: ${({ theme }) => theme.colors.gray};
    font-size: ${({ theme }) => theme.ds.typography.size.medium};
    margin-bottom: 8px;
  }

  strong {
    font-weight: ${({ theme }) => theme.font.bold};
    color: ${({ theme }) => theme.colors.primary};
    font-size: ${({ theme }) => theme.ds.typography.size.medium};
  }

  a {
    color: ${({ theme }) => theme.colors.primary};
    font-size: ${({ theme }) => theme.ds.typography.size.small};
    font-weight: ${({ theme }) => theme.font.bold};
    margin-bottom: 8px;
    text-decoration: underline;
  }

  p {
    font-weight: ${({ theme }) => theme.font.bold};
    color: ${({ theme }) => theme.colors.mediumGray};
    font-size: ${({ theme }) => theme.ds.typography.size.small};
    margin-bottom: 3px;
    margin-top: 4px;
    overflow-wrap: break-word;
  }

  span {
    font-weight: ${({ theme }) => theme.font.light};
    color: ${({ theme }) => theme.colors.mediumGray};
    font-size: ${({ theme }) => theme.ds.typography.size.small};
  }

  label {
    font-weight: ${({ theme }) => theme.font.normal};
    color: ${({ theme }) => theme.colors.gray};
  }

  & + & {
    margin-top: 4px;
  }
`

export const FlexContainer = styled.div`
  display: flex;
`

export const WrapperForm = styled.form``

export const Separator = styled.div`
  width: 1.1px;
  margin: 0 8px;
  background-color: #d1d3d7;
  justify-self: flex-end;
  align-self: stretch;
`

export const ScrollContainer = styled.div`
  max-height: 500px;
  overflow: scroll;
  overflow-x: hidden;
  margin-top: 20px;
`

export const TableWrapper = styled.div`
  display: flex;
  justify-content: center;
  margin-bottom: 30px;
`

export const Table = styled.table<any>`
  border-radius: 8px;
  border: 2px solid ${({ theme }) => theme.colors.lightBlueishGreen};
  width: ${({ width }) => width};

  .description {
    text-align: left;
    padding-left: 10px;
  }

  td {
    font-size: ${({ theme }) => theme.font.sizes.xsmall};
    text-align: center;
    padding: 7px;
  }

  th {
    font-size: ${({ theme }) => theme.font.sizes.xsmall};
  }

  th:first-child {
    padding: 1px 10px;
    text-align: left;
    width: 110px;
    text-align: center;
  }

  th:last-child {
    padding: 1px 10px;
    text-align: left;
  }

  tr:first-child {
    width: 100%;
    background-color: ${({ theme }) => theme.colors.lightestBlueishGreen};
    font-size: ${({ theme }) => theme.font.sizes.medium};
    color: ${({ theme }) => theme.colors.primary};
    text-align: center;
  }

  tr {
    height: 46px;
    font-size: ${({ theme }) => theme.font.sizes.small};
  }
`

export const SoftText = styled.p`
  font-size: ${({ theme }) => theme.font.sizes.medium};
  color: ${({ theme }) => theme.colors.mediumGray};
  font-weight: ${({ theme }) => theme.font.normal};
  margin-bottom: 10px;
  text-align: left;
`

export const ButtonPanel = styled.div`
  display: flex;
  justify-content: right;
  gap: 10px;
  margin-top: 20px;

  button {
    width: 45%;
  }
`
